
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"17","viewBox":"0 0 18 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#FFF","stroke":"#593289","d":"M5 1h8a1 1 0 011 1v3h0H4V2a1 1 0 011-1z"}}),_c('path',{attrs:{"fill":"#593289","d":"M17 13H1a1 1 0 01-1-1V5a1 1 0 011-1h16a1 1 0 011 1v7a1 1 0 01-1 1z"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#593289","d":"M12 16H6a1 1 0 01-1-1v-5h8v5a1 1 0 01-1 1z"}})])])
          )
        }
      }
    